import { Link } from "react-router";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { EASE, VIEW } from "../bits";
import { EVENT } from "./event";
import "./PatternEnvelope.css";

/* Variant D: the event as a vintage sewing-pattern envelope from a Halloween
   collection. The poster is the printed cover illustration, and the pattern's
   size chart carries the details. */

const ROWS = [
  ["Date", `${EVENT.weekday}, ${EVENT.month} ${EVENT.day}`],
  ["Time", EVENT.time],
  ["Venue", EVENT.venue],
  ["Notions", "Your hand project"],
] as const;

/** Crescent moon, two stars and a small bat, like a printed collection mark. */
function Moon() {
  return <svg className="eve-moon" viewBox="0 0 64 40" aria-hidden="true">
    <path d="M30 4a16 16 0 1 0 14 24A13 13 0 1 1 30 4Z" fill="currentColor" />
    <path d="M52 6l1.2 3 3 1.2-3 1.2L52 14.4l-1.2-3-3-1.2 3-1.2Z M8 26l.9 2.2 2.2.9-2.2.9L8 32.2l-.9-2.2-2.2-.9 2.2-.9Z" fill="currentColor" />
    <path d="M47 24c.6-1.4 1.2-2 1.2-2l.6 1.5c.6-.3 1.2-.3 1.2 0 2.4-1 5.2-1.4 8.6-.4-1.8.5-3 1.6-3 3.3-1.2-1-2.4-1-3.6 0-.6-1-1.8-1-3 .5-.6 1-1.3 2-1.8 3-.5-1-1.2-2-1.8-3-1.2-1.5-2.4-1.5-3-.5-1.2-1-2.4-1-3.6 0 0-1.7-1.2-2.8-3-3.3 3.4-1 6.2-.6 8.6.4 0-.3.6-.3 1.2 0l.6-1.5s.6.6 1.2 2Z" fill="currentColor" opacity=".9" />
  </svg>;
}

export function EventPatternEnvelope() {
  return <motion.div className="eve-wrap" initial={{ opacity: 0, y: 30, rotate: 0 }} whileInView={{ opacity: 1, y: 0, rotate: -1.5 }} viewport={VIEW} transition={{ duration: 0.6, ease: EASE }}>
    <Link to={EVENT.href} className="eve" aria-label={`${EVENT.kicker}: watch ${EVENT.film} and craft with me at ${EVENT.title}. ${EVENT.weekday}, ${EVENT.month} ${EVENT.day}, ${EVENT.time}, ${EVENT.venue}. Get tickets, ${EVENT.price}.`}>
      <span className="eve-band">
        <span className="eve-no"><small>Pattern</small>No. 10{EVENT.day}</span>
        <span className="eve-brand"><small>Halloween collection</small>{EVENT.title}</span>
        <Moon />
      </span>
      <span className="eve-body">
        <span className="eve-cover">
          <img src={EVENT.poster} alt={EVENT.posterAlt} />
          <i aria-hidden="true" />
          <span className="eve-feature">Featuring <em>{EVENT.film}</em></span>
        </span>
        <span className="eve-info">
          <span className="eve-view"><b>View A</b>{EVENT.kicker}</span>
          <span className="eve-head">{EVENT.headline[0]} <i>{EVENT.film}</i> {EVENT.headline[1]}</span>
          <span className="eve-chart">
            {ROWS.map(([k, v]) => <span key={k} className="eve-row"><span>{k}</span><b>{v}</b></span>)}
          </span>
        </span>
      </span>
      <span className="eve-tag">
        <span className="eve-tag-price">{EVENT.price}</span>
        <span className="eve-tag-go">Get tickets <ArrowRight size={13} aria-hidden="true" /></span>
      </span>
    </Link>
  </motion.div>;
}
